<template>
    <el-form-item  @mouseenter.stop.native="controlMouseOver(component, index)" @click.native="controlClick(component, index)" class="button-run" :prop="component.archive.columnId" label-width="none" :style="{'display':'flex','justify-content':component.properties.justifyContent,'align-items':component.properties.alignItems}">
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
         <el-button class="available-button" @click="click">
            {{component.name}}
        </el-button>
      </el-tooltip>
       <el-button v-else class="available-button" @click="click">
            {{component.name}}
        </el-button>
    </el-form-item>
</template>

<script>
import {componentMixin} from './mixins'

export default {
  name: 'rc-button',
  mixins: [componentMixin],
  props: ['component', 'value', 'index', 'tableCtrlKey'],
  data () {
    return {
    }
  },
  mounted () {
    const parents = document.querySelectorAll('.available-button')
    for (let i = 0; i < parents.length; i++) {
      parents[i].className = 'el-button available-button el-button--default el-button--mini'
      parents[i].disabled = false
    }
  },
  methods: {
    click () {
      this.eventBus.$emit('button.click', {component: this.component, index: this.index})
      // 触发点击事件
      this.executeFunctions('click')
    }

  }
}
</script>
<style lang="scss">
  .button-run {
    height: 100%;
    .el-button {
      padding: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-button.vue